const $ = jQuery.noConflict();

class CheckoutSlider {
    constructor() {
        this.body = 'body';
        this.slider = '.checkout-payment-slider';
        this.checkoutForm = 'form.woocommerce-checkout';
    }

    init() {
        this.initSlider();
        this.initButtons();
        this.initSelects();
    }

    initSelects() {
        const selects = $(this.checkoutForm).find('select');

        selects.each((index, el) => {
            const selectedLabel = $(el).find('option:selected').text();
            $(el).before(`<div class="select">${selectedLabel}</div>`);
        });

        selects.on('change', (el) => {
            const selectedLabel = $(el.currentTarget).find('option:selected').text();
            $(el.currentTarget).prev().text(selectedLabel);
        });
    }

    initButtons() {
        $('.wpmc-nav-wrapper button').on('click', () => {
            setTimeout(() => {
                this.initSlider();
            }, 100);
        });

        $(this.body).on('updated_checkout', () => {
            setTimeout(() => {
                this.initSlider();
            }, 100);
        });

        $(this.body).on('click', '.woo-go-back', () => {
            $('#wpmc-prev').click();
        });
    }

    initSlider() {
        if ($(this.slider).hasClass('slick-slider')) {
            $(this.slider).slick('unslick');
        }
        setTimeout(() => {
            $(this.slider).on('init', () => {
                $('.wc_payment_methods .wc_payment_method:not(:first-child)').hide();
            });

            $(this.slider).slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
            });

            $(this.slider).on('afterChange', (event, slick, currentSlide) => {
                const newMethod = $(`.wc_payment_methods .wc_payment_method:nth-child(${currentSlide + 1})`);
                newMethod.show().siblings().hide();
                newMethod.find('input').click();
            });
        }, 30);
    }
}

export default new CheckoutSlider();
